import { FC, ReactNode } from 'react';
import { cn } from '@/shared/lib';

type Props = {
  label: ReactNode;
  value: ReactNode;
  /** Пояснение под подписью — например, текст результата блока; нет — блок из подписи и значения */
  description?: ReactNode;
  className?: string;
  valueClassName?: string;
};

/**
 * Компактный блок статистики: подпись сверху, под ней пояснение, если оно есть, значение снизу.
 * Используется в детальных карточках, мини-отчёте консультанта и блоках категорий диаграмм.
 */
export const StatBox: FC<Props> = ({ label, value, description, className, valueClassName }) => (
  <div className={cn('border rounded-lg p-3', className)}>
    <div className="text-xs text-muted-foreground">{label}</div>
    {description && <div className="text-sm">{description}</div>}
    <div className={cn('text-2xl font-bold', valueClassName)}>{value}</div>
  </div>
);
